import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NewPassword from "./newPassword";
import URL_MAPPING from "../../routes/constants";
import { resetPass } from "../../api/login";
import ImageSection from "./imageSection";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const ResetPass: React.FC = () => {
  const [error, setError] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleNewPassword = async (pass: any) => {
    if (
      pass.length > 0 &&
      !pass.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/)
    ) {
      return setError(t("NewPassword.passwordPolicyError"));
    } else {
      setError("");
    }
    setError("");
    setLoader(true);
    await resetPass(token, pass)
      .then((res) => {
        if (res.data.mfa_enabled === true) {
          toast.success(t("NewPassword.success"));
          toast.success(t("NewPassword.redirectingToLogin"));
          setTimeout(() => {
            navigate(URL_MAPPING.LOGIN);
          }, 2000);
        } else {
          navigate(URL_MAPPING.GOOGLEAUTH, {
            state: { token: res?.data?.token },
          });
        }
        setLoader(false);
      })
      .catch((error) => {
        setError(error.response?.data?.detail?.message || t("NewPassword.invalidSession"));
        setLoader(false);
      });
  };

  return (
    <>
      <div className="flex h-screen flex-col md:flex-row">
        <ToastContainer />
        <div className="md:w-1/2 flex-col relative w-full h-[120px] md:h-full">
          <ImageSection />
        </div>
        <>
          <NewPassword
            handleSubmit={handleNewPassword}
            loader={loader}
            checkError={error}
          />
        </>
      </div>
    </>
  );
};

export default ResetPass;
